var assert = require("assert");

var PACK_VERSION = 2;
var MIN_VERSION = 2;

var HEADER_SIZE = 2 * Float64Array.BYTES_PER_ELEMENT + Uint8Array.BYTES_PER_ELEMENT + Uint32Array.BYTES_PER_ELEMENT;

// Optional values:
//   speed
//   distance
//   heartrate
//   cadence
//   temperature

// Currently maximum properties = 32

var properties = [
  {
    name: "latitude",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "longitude",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "height",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "time",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "terrain",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "originalHeight",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "depth",
    typeKey: 'Uint8',
    size: Uint8Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  // Optionals
  {
    name: "speed",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "distance",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "heartrate",
    typeKey: 'Uint16',
    size: Uint16Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "cadence",
    typeKey: 'Uint16',
    size: Uint16Array.BYTES_PER_ELEMENT,
    startingVal: 0
  },
  {
    name: "temperature",
    typeKey: 'Float64',
    size: Float64Array.BYTES_PER_ELEMENT,
    startingVal: 0
  }
];

var propertiesBools = function(samples) {
  return samples.reduce(function(prev, curr, index, arr) {
    var result = {};
    properties.forEach(function(k) {
      result[k.name] = (typeof prev[k.name] !== 'undefined' && !!prev[k.name]) || typeof curr[k.name] !== 'undefined';
    });
    return result;
  });
};

var filteredProperties = function(availableProperties) {
  return properties.filter(function(prop) {
    return availableProperties[prop.name];
  });
}

/**
 * Remaps the input Cartographic to reduce file size.
 */
function binariseJsonArray(inputJsonArray) {
  var beginTime = inputJsonArray[0].time;
  var endTime = inputJsonArray[inputJsonArray.length - 1].time;

  // Get properties used in this track
  propBools = propertiesBools(inputJsonArray);
  props = filteredProperties(propBools);
  packSize = props.reduce(function(prev, curr) { return curr.size + prev }, 0);

  var buffer = new ArrayBuffer(HEADER_SIZE + packSize * inputJsonArray.length);
  var view = new DataView(buffer);
  var offset = 0;
  var LE = true;

  // PACK HEADER ITEMS

  // VERSION
  view.setUint8(offset, PACK_VERSION, LE);
  offset += Uint8Array.BYTES_PER_ELEMENT;

  // BEGIN TIME OF TRACK
  view.setFloat64(offset, beginTime, LE);
  offset += Float64Array.BYTES_PER_ELEMENT;

  // END TIME OF TRACK
  view.setFloat64(offset, endTime, LE);
  offset += Float64Array.BYTES_PER_ELEMENT;

  // Get a binary mask indicating the presence of items from `properties`
  var propMask = properties.reduce(function(p,c,i,a) {
    return p + ((propBools[c.name] ? 1 : 0) * Math.pow(2,i));
  }, 0);

  // console.log("propMask", propMask, propBools);

  // Set the mask as a 32 bit integer in the binary buffer
  view.setUint32(offset, propMask, LE);
  offset += Uint32Array.BYTES_PER_ELEMENT;

  // Setup fallback values
  var fallbackVals = {};
  props.forEach(function(prop) {
    // Get first value for the property
    fallbackVals[prop.name] = inputJsonArray.find(function(item) {
      return typeof item[prop.name] !== 'undefined';
    })[prop.name];
  });


  // Iterate through points, and add the available properties for each
  for (var i = 0; i < inputJsonArray.length; i++) {
    for (var j = 0; j < props.length; j++) {
      var key = 'set' + props[j].typeKey
      var val = inputJsonArray[i][props[j].name];
      if (typeof val === 'undefined') {
        val = fallbackVals[props[j].name]
      }
      view[key](offset, val, LE);
      offset += props[j].size;
      fallbackVals[props[j].name] = val;
    }
  }

  return buffer;
}

/***************************************************************
 * EVERYTHING BELOW HERE SHOULD BE ADDED TO THE VIEWER TO UNPACK
 ***************************************************************/

function str2ab(str) {
  var arrayBuffer = new ArrayBuffer(str.length);
  var ui8a = new Uint8Array(arrayBuffer, 0);
  for (i = 0; i < str.length; i++) {
    ui8a[i] = (str.charCodeAt(i) & 0xff);
  }
  return arrayBuffer;
}

function buff2ab(buff) {
  var arrayBuffer = new ArrayBuffer(buff.length);
  var ui8a = new Uint8Array(arrayBuffer, 0);
  for (i = 0; i < buff.length; i++) {
    ui8a[i] = buff[i];
  }
  return arrayBuffer;
}

function jsonifyBinaryHeader(dataView, header) {
  var offset = 0, LE = true, beginTime, endTime;

  header.packVersion = dataView.getUint8(offset, LE); // Used to decide extraction format.
  offset += Uint8Array.BYTES_PER_ELEMENT;
  assert(header.packVersion >= MIN_VERSION, "This track format is no longer supported");
  assert(dataView.byteLength >= HEADER_SIZE);

  // Get start/stop times
  header.beginTime = dataView.getFloat64(offset, LE);
  offset += Float64Array.BYTES_PER_ELEMENT;

  header.endTime = dataView.getFloat64(offset, LE);
  offset += Float64Array.BYTES_PER_ELEMENT;

  // Set the mask as a 32 bit integer in the binary buffer
  header.mask = dataView.getUint32(offset, LE);
  offset += Uint32Array.BYTES_PER_ELEMENT;

  // Interpret the binary values of the mask
  header.props = [];
  for (var i = 0; i < properties.length; i++) {
    if (header.mask & 1<<i) { header.props.push(properties[i]); }
  }

  return offset;
}

function jsonifyBinaryPoints(dataView, header, points)
{
  var offset = 0, LE = true;
  var packSize = header.props.reduce(function(prev, curr) { return curr.size + prev }, 0);

  // Iterate through points, and add the available properties for each
  while (offset < dataView.byteLength - packSize + 1) {
    var output = {};
    for (var j = 0; j < header.props.length; j++) {
      var key = 'get' + header.props[j].typeKey
      var val = dataView[key](offset, LE);
      output[header.props[j].name] = val;
      offset += header.props[j].size;
    }
    points.push(output);
  }

  return offset;
}

/**
 * Remaps input bytes to Cartographic points.
 */
function jsonifyBinaryArray(inputBinaryArray) {
  var inputArrayBuffer = typeof inputBinaryArray === 'string' ? str2ab(inputBinaryArray) : buff2ab(inputBinaryArray);
  var view = new DataView(inputArrayBuffer);
  var offset = 0, LE = true, beginTime, endTime;

  var header = {};
  var points = [];
  offset += jsonifyBinaryHeader(view, header);
  offset += jsonifyBinaryPoints(new DataView(inputArrayBuffer, offset), header, points);

  return {
    points: points,
    beginTime: header.beginTime,
    endTime: header.endTime,
    packVersion: header.packVersion,
    mask: header.mask
  };
}

module.exports = {
  binariseJsonArray: binariseJsonArray,
  jsonifyBinaryArray: jsonifyBinaryArray,
  jsonifyBinaryHeader: jsonifyBinaryHeader,
  jsonifyBinaryPoints: jsonifyBinaryPoints,
  packVersion: PACK_VERSION
};
